module.exports = "<prg-flat-list [source]=\"(allEvents | async | creator:creatorFilter | matchingSearchText:(searchText | async)) | sortBy:'display'\"></prg-flat-list>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/list-by-name/list-by-name.component.html
// module id = 1550
// module chunks = 2